import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GET, POST, httpOk } from 'helpers/api'

/**
 * ZARUR ZAKAZLAR sozlamasi (2026-07-28).
 *
 * Cheklovsiz qilinsa bir haftada hamma zakaz «zarur» bo'lib qoladi va belgi
 * ma'nosini yo'qotadi. Shuning uchun har sotuvchiga o'rin soni beriladi.
 *
 * O'rin AYNI PAYTDA tugamagan zakazlar bo'yicha sanaladi («kuniga N ta» emas):
 * ustaga muhimi navbatda nechtasi turgani, chiqib ketgani xalal bermaydi.
 * Shu sabab o'rin o'zi bo'shaydi va tez ishlash rag'batlanadi.
 */
function Index() {
	const { t } = useTranslation()

	const [isEnabled, setIsEnabled]         = useState(true)
	const [sellerLimit, setSellerLimit]     = useState(2)
	const [ownerUnlimited, setOwnerUnlimited] = useState(true)
	const [saving, setSaving]               = useState(false)
	const [saveStatus, setSaveStatus]       = useState(null) // 'ok' | 'err'

	useEffect(() => {
		loadSettings()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	async function loadSettings() {
		const res = await GET('/urgent-settings', {}, { loader: true })
		if (httpOk(res)) {
			setIsEnabled(res.data?.is_enabled ?? true)
			setSellerLimit(res.data?.seller_limit ?? 2)
			setOwnerUnlimited(res.data?.owner_unlimited ?? true)
		}
	}

	async function save(e) {
		e.preventDefault()
		setSaving(true)
		setSaveStatus(null)
		const res = await POST('/urgent-settings', {
			is_enabled: isEnabled,
			seller_limit: Number(sellerLimit),
			owner_unlimited: ownerUnlimited,
		}, { loader: false })
		setSaving(false)
		if (httpOk(res)) {
			setSaveStatus('ok')
			setTimeout(() => setSaveStatus(null), 3000)
		} else {
			setSaveStatus('err')
		}
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">{t('urgent_settings')}</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<form onSubmit={save} style={{ maxWidth: '620px' }}>

						<div className="form-group mb-4">
							<div className="form-check form-switch form-switch-lg">
								<input type="checkbox" className="form-check-input" id="urgentEnabled"
									checked={isEnabled} onChange={(e) => setIsEnabled(e.target.checked)} />
								<label className="form-check-label" htmlFor="urgentEnabled">
									{t('urgent_enabled')}
								</label>
							</div>
							<small className="text-muted">{t('urgent_enabled_hint')}</small>
						</div>

						<div className="form-group mb-4">
							<label>{t('urgent_seller_limit')}</label>
							<input type="number" className="form-control" style={{ maxWidth: '160px' }}
								min="0" max="50" step="1" value={sellerLimit}
								onChange={(e) => setSellerLimit(e.target.value)}
								disabled={!isEnabled} />
							<small className="text-muted">{t('urgent_seller_limit_hint')}</small>
						</div>

						<div className="form-group mb-4">
							<div className="form-check form-switch form-switch-lg">
								<input type="checkbox" className="form-check-input" id="urgentOwner"
									checked={ownerUnlimited} onChange={(e) => setOwnerUnlimited(e.target.checked)}
									disabled={!isEnabled} />
								<label className="form-check-label" htmlFor="urgentOwner">
									{t('urgent_owner_unlimited')}
								</label>
							</div>
							<small className="text-muted">{t('urgent_owner_unlimited_hint')}</small>
						</div>

						<div className="alert alert-info" style={{ fontSize: '13px' }}>
							<i className="uil-info-circle me-1"></i>
							{t('urgent_info')}
						</div>

						<div className="d-flex align-items-center gap-3">
							<button type="submit" className="btn btn-primary" disabled={saving}>
								{saving ? t('saving') : t('save')}
							</button>
							{saveStatus === 'ok' && <span className="text-success">{t('saved')}</span>}
							{saveStatus === 'err' && <span className="text-danger">{t('error')}</span>}
						</div>
					</form>
				</div>
			</div>
		</>
	)
}

export default Index
